export const getCroppedImg = (imageSrc, pixelCrop) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.crossOrigin = "anonymous"; // Permet la gestion des images provenant d'autres domaines
  
      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
  
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height); // Nettoyer le canvas pour assurer la transparence
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height
        );
  
        // Convertir le canvas en base64 en conservant le format PNG pour la transparence
        const base64Image = canvas.toDataURL('image/png'); // Utilise 'image/png' pour conserver la transparence
        resolve(base64Image);
      };
  
      image.onerror = (error) => {
        reject(error);
      };
    });
  };